export default __webpack_public_path__ + "static/media/exxonmobil.e341638d.png";